import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-detail-row',
  templateUrl: './detail-row.component.html',
  styleUrls: ['./detail-row.component.scss'],
  standalone: false
})
export class DetailRowComponent {
  @Input() title: string;

  @Input() data: string;
}
